module.exports = __webpack_public_path__ + "img/image01.1be5301e.jpg";